<div class="container funnel" *ngIf="!showVerification; else verificationTpl">
  <div class="d-flex justify-content-center mt-3 m-auto">
    <div class="w-40">

      <!-- Back button and Logo placed together -->
      <div class="d-flex justify-content-between align-items-center mb-4" *ngIf="questions?.length">
        <span (click)="previousStep()" *ngIf="currentStepIndex > 0" class="badge rounded-pill py-2 px-3 badge-custom position-absolute"> <i class="fa-solid fa-chevron-left me-1"></i> Back</span>
        <div class="text-center mx-auto">
          <img src="assets/images/logo.svg" alt="logo" width="120" />
        </div>
      </div>

      <div class="progress-container" *ngIf="questions?.length">
        <mat-progress-bar mode="determinate" [value]="(currentStepIndex || 0) / (questions.length + 1) * 100"></mat-progress-bar>
      </div>

      <div *ngIf="questions?.length; else loadingTpl">

        <!-- PrimeNG Steps -->
        <!--<p-steps [model]="stepItems" [activeIndex]="currentStepIndex" [readonly]="false"></p-steps>-->

        <!-- Step Content -->
        <div class="step-content mt-4">
          <!-- Question Steps -->
          <div *ngIf="currentStepIndex < questions.length">
            <div *ngFor="let question of questions; let i = index">
              <div *ngIf="i === currentStepIndex">
                <h3 class="my-3 text-center">{{question.question_heading}}</h3>
                <h3 class="my-4 text-center">{{question.question}}</h3>
                <p class="mb-4 text-center">{{question.description}}</p>

                <div *ngIf="question.type === 'checkbox'">
                  <div *ngFor="let option of question.options; let j = index">
                    <div class="checkbox-button-container">
                      <input
                        type="checkbox"
                        id="checkbox-{{ question.id }}{{ j }}"
                        class="checkbox-btn"
                        [checked]="isAnswerChecked(question, option)"
                        (change)="onAnswerChange(question.index || question.id, 'checkbox', j , $event)"
                      />
                      <label for="checkbox-{{ question.id }}{{ j }}" class="d-flex justify-content-start align-items-center checkbox-btn-label">
                        <span class="checkbox-icon me-3"></span>
                        <span class="checkbox-text">{{option}}</span>
                      </label>
                    </div>
                  </div>
                </div>

                <div *ngIf="question.type === 'radio'">
                  <div *ngFor="let option of question.options; let j = index">
                    <div class="checkbox-button-container">
                      <input
                        type="radio"
                        id="radio-{{ question.id }}{{ j }}"
                        class="checkbox-btn"
                        name="radio-question-{{i}}"
                        [checked]="question.answer === option"
                        (change)="onAnswerChange(question.index || question.id, 'radio', j , $event)"
                      />
                      <label for="radio-{{ question.id }}{{ j }}" class="checkbox-btn-label ps-4">
                        <span class="checkbox-text">{{option}}</span>
                      </label>
                    </div>
                  </div>
                </div>

                <div *ngIf="question.type === 'dob'">
                  <div class="form-floating mb-1" *ngIf="!isMobile; else dobMobileTpl">
                    <input
                      type="text"
                      class="form-control"
                      id="dob"
                      name="dob"
                      [ngClass]="{'is-invalid': dobError}"
                      [value]="dob"
                      (input)="onDobInput($event)"
                      (blur)="validateDob(true)"
                      placeholder="MM-DD-YYYY"
                      required
                      autocomplete="off"
                    />
                    <label for="dob">MM-DD-YYYY</label>
                  </div>
                  <ng-template #dobMobileTpl>
                    <div class="form-floating mb-1">
                      <input
                        type="date"
                        class="form-control"
                        id="dob_date"
                        name="dob_date"
                        [ngClass]="{'is-invalid': dobError}"
                        [value]="dobAsDateInput"
                        (change)="onDobDateChange($event)"
                        required
                        autocomplete="off"
                      />
                      <label for="dob_date">Select Date of Birth</label>
                    </div>
                  </ng-template>
                  <div *ngIf="dobError" class="error-message">{{ dobError }}</div>
                </div>

                <div *ngIf="question.type === 'bmi'">
                  <div class="progress-wrapper">
                    <div class="current">
                      <label class="d-block">Your BMI</label>
                      <span>{{ progressValue.toFixed(1) }}</span>
                    </div>

                    <div class="w-70 m-auto">
                      <round-progress
                        [current]="progressValue"
                        [max]="50"
                        [semicircle]="true"
                        [rounded]="true"
                        [clockwise]="true"
                        [responsive]="true"
                        [stroke]="12"
                        [color]="'#C1A875'"
                      ></round-progress>
                    </div>
                  </div>

                  <div class="d-flex gap-3">
                    <div class="form-floating w-50 mb-3">
                      <input
                        type="number"
                        class="form-control"
                        id="height_feet"
                        placeholder="Height (Feet)"
                        [(ngModel)]="heightFeet"
                        (ngModelChange)="calculateBMI()"
                        name="heightFeet"
                        [ngClass]="{'is-invalid': heightFeet !== null && !isHeightFeetValid()}"
                        min="4.2"
                        max="8.4"
                        required
                      />
                      <label for="height_feet">Height (Feet)</label>
                      <div *ngIf="heightFeet !== null && !isHeightFeetValid()" class="error-message">
                        Height must be between 4.2 and 8.4 feet.
                      </div>
                    </div>
                    <div class="form-floating w-50 mb-3">
                      <input
                        type="number"
                        class="form-control"
                        id="height_inches"
                        placeholder="Height (Inches)"
                        [(ngModel)]="heightInches"
                        (ngModelChange)="calculateBMI()"
                        [ngClass]="{'is-invalid': heightInches !== null && !isHeightInchesValid()}"
                      />
                      <label for="height_inches">Height (Inches)</label>
                      <div *ngIf="heightInches !== null && !isHeightInchesValid()" class="error-message">
                        Height inches must be between 0 and 11.
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    <div class="form-floating flex-grow-1 mb-3">
                      <input
                        type="number"
                        class="form-control"
                        id="weight"
                        placeholder="Weight (lbs)"
                        [(ngModel)]="weight"
                        (ngModelChange)="calculateBMI()"
                        [ngClass]="{'is-invalid': weight !== null && !isWeightValid()}"
                      />
                      <label for="weight">Weight (lbs)</label>
                      <div *ngIf="weight !== null && !isWeightValid()" class="error-message">
                        Weight must be between 50 and 500 lbs.
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="question.type === 'weight'">
                  <div class="form-floating mb-1">
                    <input
                      type="number"
                      class="form-control"
                      id="ideal_weight"
                      [(ngModel)]="goalWeight"
                      (ngModelChange)="onGoalWeightChange()"
                      placeholder="Ideal goal weight (in lbs)"
                      [ngClass]="{'is-invalid': goalWeight !== null && goalWeightError()}"
                      required
                    />
                    <label for="ideal_weight">Ideal goal weight (in lbs)</label>
                  </div>
                  <div *ngIf="goalWeight !== null && goalWeightError()" class="error-message">{{ goalWeightError() }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Submit Step -->
          <div *ngIf="currentStepIndex === questions.length">
            <div>
              <p class="my-4 text-center">Enter your info to see your results now</p>
              <div class="form-floating mb-2">
                <input
                  type="text"
                  class="form-control"
                  id="fullName"
                  name="fullName"
                  [(ngModel)]="fullName"
                  (ngModelChange)="onFinalStepFieldChange()"
                  placeholder="Full Name"
                  required />
                <label for="fullName">Full Name</label>
              </div>

              <div class="form-floating mb-2">
                <input type="email" class="form-control" id="email" name="email" placeholder="Email Address" [(ngModel)]="email" (ngModelChange)="onFinalStepFieldChange()" [ngClass]="{'is-invalid': email && !isEmailValid()}" required />
                <label for="email">Email Address</label>
                <div *ngIf="email && !isEmailValid()" class="error-message">Please enter a valid email address.</div>
              </div>


              <div class="form-floating mb-2" (focusout)="onPhoneChangedAfterReferral()">
                <input
                  type="tel"
                  class="form-control"
                  id="phone"
                  name="phone"
                  placeholder="Phone Number"
                  [(ngModel)]="phone"
                  (ngModelChange)="onFinalStepFieldChange()"
                  mask="(000) 000-0000"
                  required
                />
                <label for="phone">Phone Number</label>
                <div *ngIf="phone && !isPhoneValid()" class="error-message">Please enter a valid phone number.</div>
              </div>

              <div class="form-floating mb-2">
                <input
                  type="text"
                  class="form-control"
                  id="address"
                  name="address"
                  placeholder="Address"
                  [(ngModel)]="address"
                  (ngModelChange)="onFinalStepFieldChange()"
                  ngx-google-places-autocomplete
                  #placesRef="ngx-places"
                  [options]="options"
                  (onAddressChange)="handleAddressChange($event)"
                  required
                />
                <label for="address">Address</label>
              </div>


              <div class="d-flex gap-2">
                <div>
                  <div class="form-floating mb-2">
                    <input
                      type="text"
                      class="form-control"
                      id="city"
                      name="city"
                      placeholder="City"
                      [(ngModel)]="city"
                      (ngModelChange)="onFinalStepFieldChange()"
                      required
                    />
                    <label for="city">City</label>
                  </div>

                </div>
                <div>
                  <div class="form-floating mb-2">
                    <input
                      type="text"
                      class="form-control"
                      id="state"
                      name="state"
                      placeholder="State"
                      [(ngModel)]="state"
                      (ngModelChange)="onStateChange()"
                      required
                    />
                    <label for="state">State</label>
                  </div>

                </div>
                <div>
                  <div class="form-floating mb-2">
                    <input
                      type="text"
                      class="form-control"
                      id="zip"
                      name="zip"
                      placeholder="Zip"
                      [(ngModel)]="zip"
                      (ngModelChange)="onFinalStepFieldChange()"
                      required
                    />
                    <label for="zip">Zip</label>
                  </div>

                </div>
              </div>

              <div class="d-flex align-items-center">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" name="consent" required [(ngModel)]="consentChecked" (ngModelChange)="onFinalStepFieldChange()">
                  <label class="form-check-label">
                    <span>I agree to the <span role="button" class="text-secondary" (click)="openTermsCondition()">terms and conditions</span></span>
                  </label>
                </div>
              </div>
            </div>
            <div class="mb-1">
              <button class="btn btn-primary btn-next py-3 mt-4 rounded-2 w-100"
                      (click)="submitAnswers()"
                      [disabled]="!canSubmit()">Submit</button>
            </div>
            <div *ngIf="existingUserError" class="error-message text-center">{{ existingUserError }}</div>
          </div>
        </div>
      </div>

      <ng-template #loadingTpl>
        <div class="loader">
          <img src="assets/images/loader.gif" alt="loader" width="100"/>
          <div class="text-center py-5">Loading...</div>
        </div>
      </ng-template>

    </div>
  </div>

</div>

<ng-template #verificationTpl>
  <div class="container funnel">
    <div class="d-flex justify-content-center mt-5 m-auto">
      <div class="w-40">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <span (click)="handleVerificationBack()" class="badge rounded-pill py-2 px-3 badge-custom position-absolute"> <i class="fa-solid fa-chevron-left me-1"></i> Back</span>
          <div class="text-center mx-auto">
            <img src="assets/images/logo.svg" alt="logo" width="120" />
          </div>
        </div>

        <h3 class="mt-5 mb-4 text-center">Verify your identity</h3>
        <p class="mb-3 text-center"><b>{{fullName}}</b></p>
        <p class="mb-4 text-center">Enter the code sent to <b>{{ displayPhone || phone }}</b> to verify</p>

        <div class="d-flex justify-content-center">
          <ng-otp-input
            (onInputChange)="onOtpChange($event)"
            [config]="otpConfig"
          >
          </ng-otp-input>
        </div>
        <div *ngIf="verificationError" class="error-message text-center mt-2">{{ verificationError }}</div>

        <button class="btn btn-primary btn-next py-2 px-4 mt-3 mb-3 rounded-2 d-block m-auto" (click)="verifyOtp()" [disabled]="verifying">{{ verifying ? 'Please wait...' : 'Verify' }}</button>
        <span class="d-block text-center" *ngIf="resendSeconds > 0">Didn't receive the code? <span class="text-secondary">Resend in {{ resendSeconds }} Seconds</span></span>
        <span class="d-block text-center" *ngIf="resendSeconds === 0">Didn't receive the code? <span role="button" class="text-secondary" (click)="resendCode()">Resend</span></span>
      </div>
    </div>
  </div>
</ng-template>

<div class="flex flex-col bottom-0 position-fixed footer-gradient justify-end w-100" *ngIf="questions?.length && !showVerification">

  <div class="w-100 mx-auto mt-5 mb-4 custom-px-4 max-width-600 footer-gradient-btn">
    <button class="btn btn-primary btn-next py-3 rounded-2 w-100"
            *ngIf="currentStepIndex !== undefined && currentStepIndex < questions.length && isAnswered(questions[currentStepIndex]?.index || questions[currentStepIndex]?.id)"
            (click)="nextStep()">Next <i class="fa fa-arrow-right ms-1"></i>
     </button>
  </div>
  <div class="my-3"></div>
  <footer class="bg-white">
    <div class="w-100 mx-auto px-5 max-width-600">
      <div class="d-flex align-items-center justify-content-between py-2">
        <div class="d-flex align-items-center">
          <img src="assets/images/hipaa.png" alt="hipaa" width="60">
        </div>
        <div>
          <img src="assets/images/hx.png" alt="hx" width="120">
        </div>
      </div>
    </div>
  </footer>

</div>
